// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"Y0-z","displaySixCardTiles":"Z0-z"};